import layout from "../layout";
import layoutGRH from "../pages/module-GRH/layout/index-grh";
export default [
    {
        path: "/grh",
        component: layoutGRH,
        children: [{
            path: "list",
            name: "list",
            component: () =>
            import ("@/pages/module-GRH/grh/index"),
        }, ],
    },
  
    {
        path: "/grh",
        component: layoutGRH,
        children: [{
            path: "update/:uuid",
            name: "update",
            component: () =>
            import ("@/pages/module-GRH/grh/update"),
            props: true,
        }, ],
    },
    {
        path: "/grh",
        component: layoutGRH,
        children: [{
            path: "detail/:uuid",
            name: "detail",
            component: () =>
            import ("@/pages/module-GRH/grh/detail"),
            props: true,
        }, ],
    },
    {
        path: "/grh",
        component: layoutGRH,
        children: [{
            path: "create",
            name: "create",
            component: () =>
            import ("@/pages/module-GRH/grh/create"),
        }, ],
    },

   




]
